var ScheduleDayOfWeekEnum = /* @__PURE__ */ ((ScheduleDayOfWeekEnum2) => {
  ScheduleDayOfWeekEnum2["Monday"] = "monday";
  ScheduleDayOfWeekEnum2["Tuesday"] = "tuesday";
  ScheduleDayOfWeekEnum2["Wednesday"] = "wednesday";
  ScheduleDayOfWeekEnum2["Thursday"] = "thursday";
  ScheduleDayOfWeekEnum2["Friday"] = "friday";
  ScheduleDayOfWeekEnum2["Saturday"] = "saturday";
  ScheduleDayOfWeekEnum2["Sunday"] = "sunday";
  return ScheduleDayOfWeekEnum2;
})(ScheduleDayOfWeekEnum || {});
export {
  ScheduleDayOfWeekEnum
};
